const useFormatDate = (date, hoursAndMinutes = false) => {
  const dateData = date.split('T')[0];
  const arrayOfDate = dateData.split('-');
  if (arrayOfDate[arrayOfDate.length - 1].length === 4) {
    return arrayOfDate.join('-');
  }
  const arrayOfDateReverse = arrayOfDate.reverse();

  if (hoursAndMinutes) {
    const hours = new Date(date).getHours();
    const minutes = new Date(date).getMinutes();

    return `${arrayOfDateReverse.join('-')} ${
      hours === 0 ? '00' : hours
    }:${minutes}`;
  }

  return arrayOfDateReverse.join('-');
};

export default useFormatDate;
